// extracted by mini-css-extract-plugin
export default {"Contact":"Contact_Contact__7Ah8j","ContactCard":"Contact_ContactCard__jdm86"};